// Constants for fetching all payments in the system
export const FETCH_PAYMENTS_REQUEST = 'FETCH_PAYMENTS_REQUEST';
export const FETCH_PAYMENTS_SUCCESS = 'FETCH_PAYMENTS_SUCCESS';
export const FETCH_PAYMENTS_FAILURE = 'FETCH_PAYMENTS_FAILURE';




// Constants for fetching payments for the logged-in user
export const FETCH_MY_PAYMENTS_REQUEST = 'FETCH_MY_PAYMENTS_REQUEST';
export const FETCH_MY_PAYMENTS_SUCCESS = 'FETCH_MY_PAYMENTS_SUCCESS';
export const FETCH_MY_PAYMENTS_FAILURE = 'FETCH_MY_PAYMENTS_FAILURE';



// Make Payment
export const INITIATE_PAYMENT_REQUEST = "INITIATE_PAYMENT_REQUEST";
export const INITIATE_PAYMENT_SUCCESS = "INITIATE_PAYMENT_SUCCESS";
export const INITIATE_PAYMENT_FAILURE = "INITIATE_PAYMENT_FAILURE";


// Fetch paynment receipt of user
export const FETCH_USER_PAYMENT_RECEIPT_REQUEST = 'FETCH_USER_PAYMENT_RECEIPT_REQUEST';
export const FETCH_USER_PAYMENT_RECEIPT_SUCCESS = 'FETCH_USER_PAYMENT_RECEIPT_SUCCESS';
export const FETCH_USER_PAYMENT_RECEIPT_FAILURE = 'FETCH_USER_PAYMENT_RECEIPT_FAILURE';
